import { G2ComparisonType } from '../components/G2Comparison'
import { AlternativeType } from '../types'
import PrismaticLogo from './images/prismatic-logo.png'
import PrismaticIcon from './images/prismatic-icon.svg'

export const linkToG2 =
  'https://www.g2.com/compare/integration-app-vs-prismatic'
export const g2Comparison: G2ComparisonType = {
  name: 'Prismatic',
  logo: PrismaticLogo.src,
  stars: 5,
  reviews: 187,
  markerSegment: (
    <>
      <b>Small-Business</b> (53.6% of reviews)
    </>
  ),
  entryLevelPricing: (
    <>
      <b>Contact Us</b>
    </>
  ),
}
export const alternative: AlternativeType = {
  name: 'Prismatic',
  logo: PrismaticLogo,
  icon: PrismaticIcon,
}
